import splitStringBySubstrings from "../../../../../../Util/functions/splitStringBySubstrings";

const UserLetter = ({ letterInput, grammar }) => {
  const errorStrings = grammar.GrammaticalErrors.map((error) => error.Error);

  console.log("Error strings:", errorStrings);
  console.log(
    "Empty errors:",
    errorStrings.filter((str) => !str || str.trim() === "")
  );

  const splitLetter = splitStringBySubstrings(
    letterInput,
    grammar.GrammaticalErrors.map((error) => error.Error)
  );

  return (
    <div className="writingGradeSectionContainer">
      <div className="writingGradeSectionHeaderContainer">
        <h2 className="writingGradeSectionHeader">Your Letter</h2>
      </div>
      <div className="writingGradeSectionBodyContainer">
        <p className="writingGradeLetterText">
          {splitLetter.map((part) => (
            <span
              style={{ color: part.isSubsection ? "#c20000" : "" }}
              key={part.text}
            >
              {part.text}
            </span>
          ))}
        </p>
      </div>
    </div>
  );
};

export default UserLetter;
